import Bugsnag from '@bugsnag/js'
import BugsnagPerformance from '@bugsnag/browser-performance'
import { version as packageVersion } from '../package.json'
import * as CryptoJS from 'crypto-js';

window.CryptoJS = CryptoJS;
//facebook browser is full of errors
let hideBugSnag = /fbclid=/.test(window.location.search);
//instagram browser has an issues with "Can't find variable: _AutofillCallbackHandler"
hideBugSnag = hideBugSnag || navigator.userAgent.indexOf("Instagram") !== -1;
hideBugSnag = hideBugSnag || navigator.userAgent.indexOf("FBAN/FBIOS") !== -1;

const ignorePatterns = [
    new RegExp("Uncaught NetworkError: Failed to execute 'importScripts' on 'WorkerGlobalScope':"),
    new RegExp("sandbox/worker.modern.js"),
    new RegExp("shopifycloud/perf-kit/shopify-perf"),
    new RegExp("wpm@"),
    new RegExp("https://decked.com/cdn/wpm/")
]

if(!hideBugSnag){
    Bugsnag.start({ 
        apiKey: 'ebe8c59d3978f0c9efccdfa80dfa2b33',
        appVersion: packageVersion,
        onError: event => {
            if (ignorePatterns.some(re => re.test(event.errors[0].errorMessage))) {
                return false
            }
          }
    });
    BugsnagPerformance.start({ apiKey: 'ebe8c59d3978f0c9efccdfa80dfa2b33' });
    window.Bugsnag = Bugsnag;
}